import FetchUtils from '../utils/fetch.utils';

export default class MerchantService {
  static BASE_URL = `${process.env.PREACT_APP_API_DOMAIN_MERCHANTS}/api/basata/user-merchant`;

  static getMerchant = async () => {
    return FetchUtils.get(MerchantService.BASE_URL);
  };

  static validateMerchant = async merchantId => {
    const body = {
      merchantId: merchantId,
    };
    return FetchUtils.post(`${MerchantService.BASE_URL}/validate`, body);
  };
}
